import ProfileFamilyFeatures from '@/components/home/ProfileFamilyFeatures'
import useCreateGroup from '@/hooks/FamilyProfile/useCreateGroup'
import useGetGroupsRoles from '@/hooks/FamilyProfile/useGetGroupsRoles'
import { colors } from '@/shahrzad-assets/shared-constants/colors'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import { fontSize } from '@/shahrzad-assets/shared-constants/fonts'
import ContentLayout from '@/shahrzad-assets/shared_components/ContentLayout'
import CustomButton from '@/shahrzad-assets/shared_components/CustomButton'
import CustomLoading from '@/shahrzad-assets/shared_components/CustomLoading'
import CInput from '@/shahrzad-assets/shared_components/Input'
import PageTitle from '@/shahrzad-assets/shared_components/PageTitle'
import { Radio, RadioChangeEvent, Space } from 'antd'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

const CreateGroup = () => {
  const [choosedRole , setChoosedRole] = useState("")
  const [groupName , setGroupName] = useState("")
  const [showError , setShowError] = useState(false)
  const { state } = useLocation()

  const { fetchGroupsRoles, groupsRolesLoading, roles } = useGetGroupsRoles()
  const { fetchGroup } = useCreateGroup({groupName});

  useEffect(() => {
    fetchGroupsRoles({ typeId: state.id })
  }, [])

  const handleChoosingRole = (e: RadioChangeEvent) => {
    setChoosedRole(e.target.value);
  }

  const handleGroupName = (value) => {
    setGroupName(value)

    if (value) {
      setShowError(false);
    } else {
      setShowError(true);
    }
  }

  const handleCreationGroup = () => {
    if (!groupName) {
      setShowError(true);
      return;
    }

    fetchGroup({
      groupTypeId: state.id,
      title: groupName,
      metaTitle: "",
      applicatorRoleId: choosedRole
    })
  }

  return (
    <>
      <PageTitle title={`گروه ${state.title}`} />
      <ContentLayout>
        <GroupDescription>
          <h4>توضیحات گروه ها</h4>
          <p className='description'>
            این گروه قابلیت ویژه‌ای را برای مدیریت افراد خانواده در اختیار شما
            قرار می‌دهد. لازم به ذکر است برای تشکیل این گروه لازم است شما سرپرست
            خانواده باشید!
          </p>
        </GroupDescription>
        <Features>
          <h4>امکانات</h4>
          <ProfileFamilyFeatures/>
        </Features>
        <GroupName>
          <CInput type='text' id='group-name' label='نام دلخواه برای گروه' value={groupName} onChange={handleGroupName}/>
          {showError && <p className='error-text'>لطفا برای گروهتان یک اسم انتخاب کنید</p>}
        </GroupName>
        <ChoosingRole>
          <h3>نقش خود را انتخاب کنید:</h3>
          {groupsRolesLoading ? (
            <CustomLoading />
          ) : (
            <Radio.Group onChange={handleChoosingRole}>
              <Space direction='vertical'>
                {
                  roles?.map((role,i) => (
                    <Radio key={i} value={role?.id}>{role?.title}</Radio>
                  ))
                }
              </Space>
            </Radio.Group>
          )}
        </ChoosingRole>
        <CreateGroupButton>
          <CustomButton width='100%' disabled={!choosedRole} onClick={handleCreationGroup}>
            ایجاد گروه
          </CustomButton>
        </CreateGroupButton>
      </ContentLayout>
    </>
  )
}

export default CreateGroup

const GroupDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${dimens.SPACING_S};
  padding: ${dimens.SPACING_XXL};

  .description {
    line-height: ${dimens.LINE_HEIGHT_LARGE};
  }
`

const GroupName = styled.div`
  padding: ${dimens.SPACING_XXL};
  padding-bottom: 0;

  .error-text {
    padding-bottom: ${dimens.SPACING_S};
    font-size: ${fontSize.SMALL};
    color: ${colors.criticalText}
  }
`

const Features = styled.div`
  padding: 0 ${dimens.SPACING_XXL};
  display: flex;
  flex-direction: column;
  gap: ${dimens.SPACING_S};
`

const ChoosingRole = styled.div`
  padding: ${dimens.SPACING_XXL};
  padding-top: ${dimens.SPACING_S};

  h3 {
    margin-bottom: ${dimens.SPACING_XL};
  }
`

const CreateGroupButton = styled.div`
  padding: ${dimens.SPACING_XXL};
`
